import { Component, Input } from '@angular/core';

/** Panel de estado vacío o informativo (sin resultados, nada que mostrar). Los errores usan app-error-ficha. */
@Component({
  selector: 'app-estado-panel',
  standalone: true,
  template: `
    <div class="state-panel" role="status">
      <i class="bi state-panel__icon" [class]="icono" aria-hidden="true"></i>
      <p class="state-panel__title">{{ titulo }}</p>
      @if (texto) { <p class="state-panel__text">{{ texto }}</p> }
      <ng-content></ng-content>
    </div>
  `
})
export class EstadoPanelComponent {
  @Input() icono = 'bi-inbox';
  @Input({ required: true }) titulo = '';
  @Input() texto = '';
}
